export const ORDER_STATUS = {
  PENDING: 'pending',
  CONFIRMED: 'confirmed',
  PROCESSING: 'processing',
  SHIPPED: 'shipped',
  DELIVERED: 'delivered',
  CANCELLED: 'cancelled',
  REFUNDED: 'refunded',
} as const;

export const ORDER_STATUS_LABELS: Record<string, { fr: string; en: string; ar: string }> = {
  pending: { fr: 'En attente', en: 'Pending', ar: 'قيد الانتظار' },
  confirmed: { fr: 'Confirmée', en: 'Confirmed', ar: 'مؤكد' },
  processing: { fr: 'En traitement', en: 'Processing', ar: 'قيد المعالجة' },
  shipped: { fr: 'Expédiée', en: 'Shipped', ar: 'تم الشحن' },
  delivered: { fr: 'Livrée', en: 'Delivered', ar: 'تم التسليم' },
  cancelled: { fr: 'Annulée', en: 'Cancelled', ar: 'ملغى' },
  refunded: { fr: 'Remboursée', en: 'Refunded', ar: 'مسترد' },
};

export const PRODUCT_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  OUT_OF_STOCK: 'out_of_stock',
  DRAFT: 'draft',
} as const;

export const PROMOTION_TYPES = {
  PERCENTAGE: 'percentage',
  FIXED: 'fixed',
  FREE_SHIPPING: 'free_shipping',
  BUY_X_GET_Y: 'buy_x_get_y',
} as const;

export const CURRENCIES = ['EUR', 'USD', 'KMF'] as const;
export type Currency = (typeof CURRENCIES)[number];

export const CURRENCY_SYMBOLS: Record<Currency, string> = {
  EUR: '€',
  USD: '$',
  KMF: 'KMF',
};

// Exchange rates (EUR as base)
export const EUR_TO_USD = 1.1;
export const EUR_TO_KMF = 500;
export const USD_TO_EUR = 1 / EUR_TO_USD;
export const KMF_TO_EUR = 1 / EUR_TO_KMF;

export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  SIGNUP: '/signup',
  FORGOT_PASSWORD: '/forgot-password',
  DASHBOARD: '/',
  ORDERS: '/orders',
  PRODUCTS: '/products',
  SHOPS: '/shops',
  PROMOTIONS: '/promotions',
  SHIPPING: '/shipping',
  WALLET: '/wallet',
  METRICS: '/metrics',
  EMPLOYEES: '/employees',
  ADS: '/ads',
  SETTINGS: '/settings',
} as const;
